import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { Action } from 'src/app/core-module/models/Compliance-Actions/action';
import { ActionResponse } from 'src/app/core-module/models/Compliance-Actions/action-response';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { ComplianceActionService } from 'src/app/core-module/services/compliance-action.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
  selector: 'app-compact-action-panel',
  templateUrl: './compact-action-panel.component.html',
  styleUrls: ['./compact-action-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompactActionPanelComponent implements OnChanges {
  @Input() action!: Action;
  @Input() origin: 'actions' | 'home' = 'actions';
  @Input() filterState: string = '';
  @Input() forceExpanded: boolean = false;
  @Output() Refresh = new EventEmitter<void>();
  public expanded = false;
  public ar = new ActionResponse();
  public saving = false;
  public noteWarning = false;

  constructor(
    private util: UtilService,
    private router: Router,
    private CAS: ComplianceActionService,
    private toast: ToastrService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['forceExpanded']) {
      this.expanded = !!this.forceExpanded;
    }
    if (changes['action'] && this.action) {
      this.ar = new ActionResponse();
      this.ar.ActionID = this.action.ActionID;
      this.ar.Resolved = this.action.Resolved;
      this.noteWarning = false;
    }
  }

  getDeadlineText(date: Date): string {
    return this.util.humanDate(new Date(date));
  }

  isOverdue(date: Date): boolean {
    return this.util.stripTime(date) < this.util.stripTime(new Date());
  }

  isDueToday(date: Date): boolean {
    return this.util.stripTime(date).toString() === this.util.stripTime(new Date()).toString();
  }

  detailAction(action: Action) {
    const params: any = { id: action.ActionID, from: this.origin };
    if (this.filterState) {
      params.filters = this.filterState;
    }
    this.router.navigate(['/actionv2'], { queryParams: params });
  }

  updateAction() {
    if (!this.action) {
      return;
    }
    this.saving = true;
    this.ar.ActionID = this.action.ActionID;
    this.CAS.updateAction(this.ar).pipe(
      tap((res: BasicResult) => {
        this.saving = false;
        if (res?.IsError) {
          this.toast.addToastr(new Toastr({ Type: 4, Message: 'Unable to update action, please try again.' }));
          return;
        }
        this.toast.addToastr(new Toastr({ Type: 2, Message: 'Action updated.' }));
        this.Refresh.emit();
      })
    ).subscribe({
      error: () => {
        this.saving = false;
        this.toast.addToastr(new Toastr({ Type: 4, Message: 'Unable to update action, please try again.' }));
      }
    });
  }

  formatDescription(): string {
    const desc = this.action?.ActionDescription || this.action?.WorkflowActionTitle || 'Action';
    if (!desc) {
      return '';
    }
    const chunkWord = (word: string) => {
      if (word.length <= 50) {
        return word;
      }
      const pieces: string[] = [];
      for (let i = 0; i < word.length; i += 50) {
        pieces.push(word.slice(i, i + 50));
      }
      return pieces.join(' ');
    };
    return desc
      .split(' ')
      .map(chunkWord)
      .join(' ');
  }
}
